export const TEXT_THEME = {
  textV1: {
    xs: "1rem",
    sm: "1rem",
    md: "1.25rem",
    lg: "1.25rem",
    xl: "1.5rem",
  },

  textV2: {
    xs: "1.25rem",
    sm: "2rem",
    md: "2rem",
    lg: "2.0rem",
    xl: "2.0rem",
  },
  textV3: {
    xs: "0.75rem",
    sm: "1rem",
    md: "1rem",
    lg: "1rem",
    xl: "1.25rem",
  },
  CV1: "clamp(1rem, 2.5vw, 1.25rem)",
  CV2: "clamp(0.75rem, 2.5vw, 1rem)",
}

export const SPACING_THEME = {
  marginBottomVariant1: {
    xs: "4rem",
    sm: "4rem",
    md: "4rem",
    lg: "4rem",
    xl: "6rem",
  },

  marginRightV1: { xs: "2rem", sm: "2rem", md: "3rem", lg: "4rem", xl: "5rem" },
  paddingPropertyInformation: {
    xs: "1.75rem",
    sm: "2rem",
    md: "3rem",
    lg: "4rem",
    xl: "4rem",
  },
}

export const IMAGE_GRID_SIZE_THEME = {
  boxArrayIcon: {
    xs: "8rem",
    sm: "9rem",
    md: "10rem",
    lg: "11rem",
    xl: "12rem",
  },

  bedConfigBox: {
    height: { xs: "6rem", sm: "7rem", md: "8rem", lg: "9rem", xl: "10rem" },
    width: {
      xs: "14rem",
      sm: "15rem",
      md: "16rem",
      lg: "17.5rem",
      xl: "17.5rem",
    },
  },

  propertyInformationImage: {
    height: { xs: "4rem", sm: "4rem", md: "4rem", lg: "4rem", xl: "4rem" },
    width: { xs: "4rem", sm: "4rem", md: "4rem", lg: "4rem", xl: "4rem" },
  },

  propertyInformationIcon: {
    height: { xs: "7.5rem", sm: "9rem", md: "10rem", lg: "10rem", xl: "10rem" },
    width: { xs: "7.5rem", sm: "9rem", md: "10rem", lg: "10rem", xl: "10rem" },
  },
}

export const COLORS = {
  textWhite: "#FFF",

  // Customer Module
  customerAppBgColor: "#1D2319",
  customerAppOutlineColor: "#3CA63C",
  customerAppOutlineSecondary: "rgba(255, 255, 255, 0.2)",
  customerAppTextPrimary: "#FFFFFFB2",
  customerAppPrimaryButton: "#3CA63C",
  customerAppSecondaryButton: "#2A7221",
  customerAppTertiaryButton: "#6F6F6F",

  // Admin App
  adminAppBgColor: "#1C2218",
  adminAppTextPrimary: "#FFFFFFB2",
  adminAppTextSecondary: "#E7E3FC",
  adminAppOutlineColor: "#3CA63C",
  adminAppBgColorV2: "#272D24",
  darkGreen: "#2E5319",
  blue: "#1f4066",
  lightGreen: "#799612",
  adminAppPrimaryButton: "#1B920A",

  // Surfaces
  surfaceDark: "#292A29",

  // Texts
  textPrimary: "#38B000",
}
